import { render, staticRenderFns } from "./CardCompassYearsNew.vue?vue&type=template&id=054c51ee&scoped=true&"
import script from "./CardCompassYearsNew.vue?vue&type=script&lang=ts&"
export * from "./CardCompassYearsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c51ee",
  null
  
)

export default component.exports